import DiamondRoundedIcon from "@mui/icons-material/DiamondRounded";
import { useContext, useState } from "react";
import { FieldsSettingsContext } from "../../CustomNotificationPage";
import { field_IDs_mapping } from "../../fieldMapping";
import SettingsList from "../components/SettingsList";
import SettingsSection from "../components/SettingsSection";

export default function CriticalAssetsNotificationsSection() {
  const [fetchStatus, setFetchStatus] = useState(null);
  const getFieldsSettingsData = useContext(FieldsSettingsContext);

  const settingsFields = Object.values(field_IDs_mapping.CRITICAL_ASSETS);

  const settingsData = getFieldsSettingsData(settingsFields);

  return (
    <SettingsSection
      title="Critical Assets"
      Icon={DiamondRoundedIcon}
      fetchStatus={fetchStatus}
      setFetchStatus={setFetchStatus}
    >
      <SettingsList
        settingsData={settingsData}
        setFetchStatus={setFetchStatus}
      />
    </SettingsSection>
  );
}
